module.exports = "html, body {\n  height: 100%;\n  font-family: 'Roboto', Helvetica, Arial, sans-serif; }\n\n.container {\n  max-width: 800px;\n  width: 100%;\n  height: 100%; }\n\n.svg-container {\n  width: 500px; }\n\np {\n  font-size: 21px; }\n\n@media (max-width: 767px) {\n    p {\n      font-size: 16px; } }\n\nh1 {\n  font-size: 32px; }\n\n@media (max-width: 767px) {\n    h1 {\n      font-size: 21px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/empty-site/empty-site.component.scss
// module id = ./src/app/core/empty-site/empty-site.component.scss
// module chunks = main